import { HeadLine } from "../../../layouts/headers/HeadLine"
import CSS from 'csstype';
import GeneralButtonComponent from "../../../components/button/GeneralButtonComponent";
import FoodCardCounterList from "../components/FoodCardCounterList";

const SelectManyFood = () => {

    const bgimage: CSS.Properties = { backgroundImage: 'url(../../../../assets/img/svg/cafes_bg.svg)' };

    const cafes = [
        {
            name: 'Café Americano',
            img: 'cafe1-img.svg'
        },
        {
            name: 'Café Latte',
            img: 'cafe2-img.svg'
        },
        {
            name: 'Café Espresso',
            img: 'cafe3-img.svg'
        },
        {
            name: 'Café Cappucino',
            img: 'cafe4-img.svg'
        }
    ]

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Room Service' backurl='/room-service' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="flex justify-center items-center" style={msgWarnStyle}>
                    <span>Este servicio no tiene ningún costo</span>
                </div>
                <div className="bg_detail_food" style={bgimage}>

                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-process-food-container pb-4">
                <div className="mt-4" style={typeFoodstyles}>Variedad de Café</div>
                <p className="mt-4" style={{ fontSize: '14px' }}>
                    Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de A.
                </p>

                <FoodCardCounterList items={cafes} />

                <div className="mt-8 flex justify-center">
                    <GeneralButtonComponent classes="primary_btn hover:primary_btn text-white py-2 px-6" bgcolor="#67BAAF"> Solicitar Café </GeneralButtonComponent>
                </div>
            </div>

        </>
    )
}

const msgWarnStyle: CSS.Properties = {
    color: '#012349',
    height: '40px',
    fontSize: '14px',
    backgroundColor: '#FFE36F',
    width: '100vw',
    marginLeft: '-14px',
    marginTop: '-14px',
    fontWeight: '600'
}

const typeFoodstyles: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}

export default SelectManyFood
